import devConfig from "./development.json";
import stagConfig from "./staging.json";
import localSTConfig from "./dev-staging.json";
import prodConfig from "./production.json";
import globalConfig from "./global.json";

const configSources: any = {
    development: devConfig,
    devStaging: localSTConfig,
    staging: stagConfig,
    production: prodConfig
}

const object = configSources[import.meta.env.MODE] ? configSources[import.meta.env.MODE] : configSources.development
type jsonKeyType = keyof typeof globalConfig | keyof typeof devConfig | keyof typeof prodConfig
export const config = (key: jsonKeyType) => {

    const mergedObject = Object.assign(globalConfig, object)
    let returnValue: any;
    try {
        key = (key as any).replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        key = (key as any).replace(/^\./, '');           // strip a leading dot
        const a = (key as any).split('.');
        for (let i = 0, n = a.length; i < n; ++i) {
            const k = a[i];
            if (k in mergedObject) {
                returnValue = mergedObject[k];
            } else {
                return;
            }
        }
        return returnValue;
    } catch (error) {
        return undefined
    }
}

